import * as React from 'react'
import {connect} from 'react-redux'
import {ApplicationState, ConnectedReduxProps} from '@reducers/index'
import {Image} from '@models/image'
import {deleteRequest, fetchRequest} from '@actions/image'
import TableRenderer from "@hocs/TableRenderer";
import ImagesList from "@components/images/List";
import {getImagesList} from "@reducers/image";
import {FormattedMessage} from 'react-intl';
import {Button, Card} from "antd";
import ImageForm from "@components/images/Form";
import SearchImagesComponent from "@components/images/Search";


interface PropsFromState {
  loading: boolean
  data: Image[]
  errors?: string,
  count: number
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest
  deleteRequest: typeof deleteRequest,
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps


class ImagesIndexPage extends React.Component<AllProps> {
  
  deleteImage = (item: Image): any => {
    this.props.deleteRequest({
      params: {
        id: item.id
      }
    })
  };
  
  render() {
    const {loading, data, search} = this.props;
    return (
      <div>
        <div className={`toggle-button-wrapper`}>
          <ImageForm toggleButton={(
            <Button type={'primary'}><FormattedMessage id="app.upload_new_image"
                                                       defaultMessage={`Upload Image`}/></Button>
          )}/>
        </div>
        <div className={'page-table-wrapper'}>
          <Card className={`page-table-header`}>
            <SearchImagesComponent search={search}/>
          </Card>
          
          <ImagesList data={data}
                      deleteFn={this.deleteImage}
                      loading={loading}/>
        </div>
      
      </div>
    )
  }
}

const mapStateToProps = ({images}: ApplicationState) => ({
  loading: images.loading,
  data: getImagesList(images),
  count: images.count,
});

const mapDispatchToProps = {
  fetchRequest,
  deleteRequest
};


export default connect(mapStateToProps, mapDispatchToProps)(TableRenderer(ImagesIndexPage));
